import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { createContext, useCallback, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { cookies, noop } from "@catchoftheday/utilities";
import { OVER_18_COOKIE_NAME } from "../consts";
import { removeMultipleQueryStringKeys, removeQueryStringKey, removeQueryStringValue, updateMultipleQueryStringValues, updateQueryStringValue } from "../utilities/api";
import { jsx as ___EmotionJSX } from "@emotion/react";
var over18cookie = OVER_18_COOKIE_NAME;
export var CatalogueContext = /*#__PURE__*/createContext({
  addFilterValue: noop,
  addMultipleFilterValues: noop,
  removeFilterValue: noop,
  removeFilterKey: noop,
  removeAllFilters: noop,
  searchResponse: null,
  updateSearchResponse: noop,
  isSearchLoading: false,
  updateSearchLoading: noop,
  safeSearchEnabled: true,
  toggleSafeSearch: noop,
  mobileFacetsOpen: false,
  toggleMobileFacets: noop
});
export var CatalogueContextProvider = function CatalogueContextProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      searchResponse = _useState[0],
      setSearchResponse = _useState[1];

  var _useState2 = useState(false),
      isSearchLoading = _useState2[0],
      setIsSearchLoading = _useState2[1];

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      safeSearchEnabled = _React$useState2[0],
      setSafeSearchEnabled = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      mobileFacetsOpen = _React$useState4[0],
      setMobileFacetsOpen = _React$useState4[1];

  useEffect(function () {
    var isAdult = cookies.get(over18cookie) === "true";
    setSafeSearchEnabled(!isAdult);
  }, []);
  var router = useRouter();
  var addFilterValue = useCallback(function (key, value, allowMultiple) {
    updateQueryStringValue(router, key, value, allowMultiple);
  }, [router]);
  var addMultipleFilterValues = useCallback(function (params) {
    updateMultipleQueryStringValues(router, params);
  }, [router]);
  var removeFilterValue = useCallback(function (key, value) {
    removeQueryStringValue(router, key, value);
  }, [router]);
  var removeFilterKey = useCallback(function (key) {
    removeQueryStringKey(router, key);
  }, [router]);
  var removeAllFilters = useCallback(function () {
    removeMultipleQueryStringKeys(router, "f.");
  }, [router]);
  var updateSearchResponse = useCallback(function (response) {
    setSearchResponse(response);
  }, []);
  var updateSearchLoading = useCallback(function (loading) {
    setIsSearchLoading(loading);
  }, []);

  var toggleSafeSearch = function toggleSafeSearch() {
    var isChecked = !safeSearchEnabled;
    setSafeSearchEnabled(isChecked);

    if (isChecked) {
      cookies.remove(over18cookie);
    } else {
      cookies.set(over18cookie, "true", {
        expires: 30
      });
    }
  };

  var toggleMobileFacets = function toggleMobileFacets() {
    setMobileFacetsOpen(function (prev) {
      return !prev;
    });
  };

  return ___EmotionJSX(CatalogueContext.Provider, {
    value: {
      addFilterValue: addFilterValue,
      addMultipleFilterValues: addMultipleFilterValues,
      removeFilterValue: removeFilterValue,
      removeFilterKey: removeFilterKey,
      removeAllFilters: removeAllFilters,
      searchResponse: searchResponse,
      updateSearchResponse: updateSearchResponse,
      isSearchLoading: isSearchLoading,
      updateSearchLoading: updateSearchLoading,
      safeSearchEnabled: safeSearchEnabled,
      toggleSafeSearch: toggleSafeSearch,
      mobileFacetsOpen: mobileFacetsOpen,
      toggleMobileFacets: toggleMobileFacets
    }
  }, children);
};